import React from 'react';
import {
  GoogleIcon,
  KakaoIcon,
  AppleIcon,
  MailIcon,
} from './components/SocialIcons/SocialIcons';
import './SocialLoginButtons.css';

export function SocialLoginButtons({ onOAuthLogin, onEmailClick, isLoading }) {
  return (
    <div className="social-login-buttons">
      <button
        type="button"
        className="social-btn social-btn--google"
        onClick={() => onOAuthLogin('google')}
        disabled={isLoading}
      >
        <span className="social-btn__icon">
          <GoogleIcon size={22} />
        </span>
        <span className="social-btn__text">Google로 로그인</span>
      </button>

      <button
        type="button"
        className="social-btn social-btn--kakao"
        onClick={() => onOAuthLogin('kakao')}
        disabled={isLoading}
      >
        <span className="social-btn__icon">
          <KakaoIcon size={20} />
        </span>
        <span className="social-btn__text">카카오로 로그인</span>
      </button>

      <button
        type="button"
        className="social-btn social-btn--apple"
        onClick={() => onOAuthLogin('apple')}
        disabled={isLoading}
      >
        <span className="social-btn__icon">
          <AppleIcon size={22} />
        </span>
        <span className="social-btn__text">Apple로 로그인</span>
      </button>

      <button
        type="button"
        className="social-btn social-btn--email"
        onClick={onEmailClick}
        disabled={isLoading}
      >
        <span className="social-btn__icon">
          <MailIcon size={20} />
        </span>
        <span className="social-btn__text">이메일로 로그인</span>
      </button>
    </div>
  );
}
